import React from "react";
import DynamicForm from "../../components/AdvanceDynamicCreate/DynamicForm";
import { getStoredData } from "../../json/fecthData";

const InventoryPanelCreate = () => {
  // Fetch stored inventory data
  const inventoryData = getStoredData()?.[1] || {}; // Adjust index if needed

  return (
    <div>
      <h2>Create New {inventoryData.TitleInventory}</h2>
      <DynamicForm
        fields={inventoryData.AdminInventory} // Pass dynamic fields
        apiUrl={inventoryData.ApiInventory} // Use correct API URL
        successRedirect={inventoryData.RedirectAdminInventory} // Redirect after submission
      />
    </div>
  );
};

export default InventoryPanelCreate;
